import { TargetAccountIcon } from './TargetAccountIcon';

/**
 * author: Austin Andrews
 * id 9B5EC357-642F-4790-BD58-E45A217DD9B9
 * name target-account
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/target-account.svg
 * tags
 * - Account / User 
 */
export const TargetUserIcon = TargetAccountIcon;
export default TargetUserIcon